import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ConciergeErrorResponse } from 'src/api/concierge';

import { BookingsEndpoints, getVoucherCode } from '../api';

type QueryConfig = UseQueryOptions<string | null, AxiosError<ConciergeErrorResponse>>;

export const useGetVoucherCode = (config: QueryConfig = {}) => {
    const query = useQuery<string | null, AxiosError<ConciergeErrorResponse>>({
        queryKey: [BookingsEndpoints.getVoucherCode],
        queryFn: getVoucherCode,
        ...config,
    });

    return query;
};
